<script lang="ts">
  import { onMount } from 'svelte';
  import { db, type SessionRecord } from '../lib/db';

  let sessions = $state<SessionRecord[]>([]);

  onMount(async () => {
    sessions = await db.sessions.orderBy('createdAtMs').reverse().toArray();
  });

  function fmtDate(ms: number): string {
    return new Date(ms).toLocaleString('pt-BR');
  }
  function fmtDur(ms: number): string {
    const s = Math.round(ms / 1000);
    return `${Math.floor(s / 60)}m ${s % 60}s`;
  }
</script>

<section class="flex h-full flex-col items-stretch p-6">
  <header class="flex items-center justify-between pb-6">
    <h1 class="text-3xl font-bold tracking-tight">Tenis Coach</h1>
    <div class="flex items-center gap-2">
      <a
        href="#/test"
        class="rounded-full bg-slate-700 px-4 py-3 text-sm font-semibold text-slate-100 active:scale-95"
      >
        Testar com vídeo
      </a>
      <a
        href="#/record"
        class="rounded-full bg-court px-6 py-3 text-lg font-semibold text-slate-900 shadow-lg active:scale-95"
      >
        Gravar
      </a>
    </div>
  </header>

  <h2 class="pb-2 text-sm uppercase tracking-wider text-slate-400">Sessões anteriores</h2>

  {#if sessions.length === 0}
    <p class="rounded-md border border-dashed border-slate-700 p-6 text-center text-slate-400">
      Nenhuma sessão ainda. Aperte <strong>Gravar</strong> para começar.
    </p>
  {:else}
    <ul class="flex flex-col gap-2 overflow-y-auto">
      {#each sessions as s (s.id)}
        <li>
          <a
            href={`#/swings/${s.id}`}
            class="flex items-center justify-between rounded-md bg-slate-800 p-3 active:bg-slate-700"
          >
            <div>
              <div class="font-semibold">{fmtDate(s.createdAtMs)}</div>
              <div class="text-sm text-slate-400">
                {fmtDur(s.durationMs)} · {s.swings.length} swings · {s.fps.toFixed(0)} fps
              </div>
            </div>
            <span class="text-2xl text-slate-500">›</span>
          </a>
        </li>
      {/each}
    </ul>
  {/if}
</section>
